import { Box, Button, Container, List, ListItem } from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import SalesPartnerDetailsTabs from './SalesPartnerDetailsTabs';

const nav = '/settings/salesPartner';

const SalesPartnerDetails = () => {
  return (
    <>
      <List component="div">
        <ListItem component="div">
          <Button
            variant="contained"
            sx={{
              background: '#E55D22',
              margin: '0 10px 0 auto',
              '&:hover': { backgroundColor: 'rgba(229, 93, 34, 0.8)' }
            }}
            onClick={() => {
              
            }}
            component={RouterLink}
            to={nav}
          >
            <KeyboardBackspaceIcon />
            Back
          </Button>
        </ListItem>
      </List>
      <Container maxWidth="xl">
        <Box
          sx={{
            width: 'auto',
            padding: '3px',
            p: 6,
            background: 'transparent',
            boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.2)',
            minHeight: '500px'
          }}
        >
          <SalesPartnerDetailsTabs />
        </Box>
      </Container>
    </>
  );
};

export default SalesPartnerDetails;
